import {
  Icon,
  NewTask,
  DeleteModal,
  DisabledTag,
  getTranslatedText,
  B1,
  Tag,
  BackgroundIcon,
  Column,
  Row,
  AccessControl,
  isAuthorised,
  getPriorityBadgeStatus,
  getPriorityLabel
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import StatusHolder from '@nile/projects/src/Components/Elements/StatusHolder';
import { renderTime } from '@nile/projects/src/Utils';
import {
  Button,
  Card,
  Heading,
  Avatar,
  DisplayText,
  Link,
  Badge
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { Trash, Pen, Folder, Stopwatch } from '@styled-icons/fa-solid';
import React, { useState, useContext, Fragment } from 'react';
import styled from 'styled-components';
import { injectIntl, FormattedMessage } from 'react-intl';
import dompurify from 'dompurify';
import { PROJECT_STATUSES } from '@nile/projects/src/Components/Cards/ProjectListItem';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';
import { Tooltip } from 'react-clone-tippy';

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;

  &.secondCol {
    &.no-visibility {
      visibility: hidden;
    }
  }

  .deleteBtn :hover {
    color: #e02020;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 1.2rem !important;
  gap: 5px;
  /* margin-top: 2rem; */
  .fx {
    flex: 1 1;
    align-items: center;
    font-weight: 700;
  }
`;

const Wrapper = styled.div`
  .Polaris-Card {
    border-radius: 0px !important;
    margin: 0 !important;
    box-shadow: none !important;
    margin-bottom: 20px;
    /* border-bottom: 0.1rem solid rgba(0, 0, 0, 0.2); */
  }

  margin: 10px 0;
  padding: 10px 5px;
`;

const TaskCard = ({
  intl,
  task,
  handleTaskDeletion,
  handleTaskUpdation,
  index,
  module,
  details,
  disableActions,
  disableDelete,
  disableEdit,
  isTicketDetailsPage,
  disableView,
  enableDrag
}) => {
  const [sheetActive, setSheetActive] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };
  const {
    title,
    techGroup,
    technician,
    description,
    status,
    estimatedTime,
    scheduledStartDate,
    dueDate,
    priority
  } = task;

  const handleDeletion = (toggleSheet) => {
    handleTaskDeletion(index);
    if (toggleSheet) {
      toggleSheetActive();
    }
  };

  const handleUpdation = (updated) => {
    handleTaskUpdation(index, updated);
    toggleSheetActive();
  };

  return (
    <>
      <Wrapper
        className="taskCard visibilityContainer purple-hover"
        data-qa={`task-${index}`}
        onMouseOver={() => setShowOptions(true)}
        onMouseLeave={() => setShowOptions(false)}
      >
        <div
          className={
            isTicketDetailsPage && 'white-to-grey-bg pl5 pr5 pt20 pb20'
          }
        >
          <Row gap={5}>
            {enableDrag ? (
              <SuperSortable.DragHandle className="pt-5 visibilityActions" />
            ) : (
              <div className="pl-15" />
            )}
            <Column className="full-width">
              <Row gap={5}>
                <OuterWrapper className="flex-1-1-auto ellipsis">
                  {disableView ? (
                    <div className="flex center">
                      {priority && (
                        <span className="tw-mr-2">
                          <Badge status={getPriorityBadgeStatus(priority)}>
                            {getPriorityLabel(priority)}
                          </Badge>
                        </span>
                      )}
                      <DisplayText size="large">{title}</DisplayText>
                    </div>
                  ) : (
                    <div className="flex center">
                      {priority && (
                        <span className="tw-mr-2">
                          <Badge status={getPriorityBadgeStatus(priority)}>
                            {getPriorityLabel(priority)}
                          </Badge>
                        </span>
                      )}
                      <Link
                        onClick={toggleSheetActive}
                        ellipsis
                        fontWeight="normal"
                      >
                        <Tooltip
                          title={title}
                          delay={200}
                          duration={250}
                          position="bottom"
                          inertia
                          trigger="mouseenter"
                          animation="shift"
                          animateFill={false}
                        >
                          <div className="ellipsis">{title}</div>
                        </Tooltip>
                      </Link>
                    </div>
                  )}
                </OuterWrapper>
                <div className="uppercase flex-0-0-10">
                  <Tag
                    active={PROJECT_STATUSES.ACTIVE.includes(
                      status ||
                        getTranslatedText(intl, 'project.task.status.planned')
                    )}
                    smooth={PROJECT_STATUSES.NORMAL.includes(
                      status ||
                        getTranslatedText(intl, 'project.task.status.planned')
                    )}
                  >
                    {status ||
                      getTranslatedText(intl, 'project.task.status.planned')}
                  </Tag>
                </div>
                {!disableActions && (
                  <OuterWrapper
                    className={
                      showOptions
                        ? 'secondCol flex-0-0-10'
                        : 'secondCol no-visibility flex-0-0-10'
                    }
                  >
                    {!disableDelete && (
                      <div className="deleteBtn" data-qa="deleteTaskBtn">
                        <DeleteModal
                          description={getTranslatedText(
                            intl,
                            'ticket.details.task.delete.confirm'
                          )}
                          handleDeleteConfirmation={handleDeletion}
                          title={getTranslatedText(
                            intl,
                            'ticket.details.task.delete.text'
                          )}
                          destructive
                          plain
                        />
                      </div>
                    )}
                  </OuterWrapper>
                )}
              </Row>
              <InnerWrapper className="mt-10">
                <div className="fx actr">
                  <div className="mr-10">
                    <SVGIcon name="TechnicianGroup" />
                  </div>
                  {techGroup ? (
                    <div>{techGroup?.name || 'NA'}</div>
                  ) : (
                    <DisabledTag>
                      <FormattedMessage id="app.noData.message" />
                    </DisabledTag>
                  )}
                </div>
                <div className="fx actr">
                  <div className="mr-10">
                    <Avatar customer name="technician" size="extraSmall" />
                  </div>
                  {technician ? (
                    `${technician.firstName} ${technician.lastName}`
                  ) : (
                    <DisabledTag>
                      <FormattedMessage id="app.noData.message" />
                    </DisabledTag>
                  )}
                </div>
                <div className="fx actr">
                  <div className="mr-10">
                    <SVGIcon name="EstimatedTime" />
                  </div>
                  {renderTime(estimatedTime) || (
                    <DisabledTag>
                      <FormattedMessage id="app.noData.message" />
                    </DisabledTag>
                  )}
                </div>
              </InnerWrapper>
            </Column>
          </Row>
        </div>
      </Wrapper>

      {sheetActive && (
        <NewTask
          addOrUpdateTechGroup={(type, updated) => {
            return handleUpdation(updated);
          }}
          state={sheetActive}
          toggleSheetActive={toggleSheetActive}
          name={title}
          hideIcon
          isLink
          data={task}
          module={module || 'PROJECT_TASK'}
          details={details || { operation: 'CREATE' }}
          onDeleteHandler={() => handleDeletion(true)}
          locked
          noRender
        />
      )}
    </>
  );
};

export default injectIntl(TaskCard);
